import React, { useEffect, useRef, useState } from "react";
import "./Counter.css";

const countersData = [
  { label: "Industry Experience", value: 9, suffix: "+" },
  { label: "Positive Result", value: 99, suffix: "%" },
  { label: "Clients Rating", value: 4.9, suffix: "" },
  { label: "Projects Completed", value: 250, suffix: "+" },
];

const CounterSection = () => {
  const [counts, setCounts] = useState(countersData.map(() => 0));
  const sectionRef = useRef(null);
  const intervalRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startCounting();
          } else {
            resetCounting();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const startCounting = () => {
    resetCounting(); // clear previous

    countersData.forEach((item, index) => {
      let start = 0;
      const end = item.value;
      const speed = 30; // fast & smooth

      intervalRefs.current[index] = setInterval(() => {
        start += 1;

        if (start >= end) {
          start = end;
          clearInterval(intervalRefs.current[index]);
        }

        setCounts((prev) => {
          const updated = [...prev];
          updated[index] = start;
          return updated;
        });
      }, speed);
    });
  };

  const resetCounting = () => {
    intervalRefs.current.forEach((int) => clearInterval(int));
    setCounts(countersData.map(() => 0));
  };

  return (
    <section className="counter-section" ref={sectionRef}>
      <div className="counter-container">
        {countersData.map((item, index) => (
          <div className="counter-box" key={index}>
            <div className="counter-number">
              {counts[index]}
              {item.suffix}
            </div>
            <div className="counter-label">{item.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CounterSection;
